import { ButtonHTMLAttributes, forwardRef } from 'react';

import { cn } from '@/lib/utils';

type Fill = 'paper' | 'ink' | 'lost' | 'found' | 'solved' | 'urgent' | 'accent';
type Size = 'sm' | 'md';

export interface NbButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  fill?: Fill;
  size?: Size;
}

const FILL_CLASS: Record<Fill, string> = {
  paper: 'fill-paper',
  ink: 'fill-ink',
  lost: 'fill-lost',
  found: 'fill-found',
  solved: 'fill-solved',
  urgent: 'fill-urgent',
  accent: 'fill-accent',
};

export const NbButton = forwardRef<HTMLButtonElement, NbButtonProps>(
  ({ fill = 'paper', size = 'md', className, type = 'button', ...rest }, ref) => (
    <button
      ref={ref}
      type={type}
      className={cn('nb-btn', FILL_CLASS[fill], size === 'sm' && 'nb-btn-sm', className)}
      {...rest}
    />
  ),
);
NbButton.displayName = 'NbButton';
